(<template>
    <div class="list" id="walk-list">
      <h1 v-translate>Themed walks</h1>
      <div class="create-button-container">
        <el-button v-if="$session.exists() && $route.path !=='/'"
                   id="button-add-walk"
                   type="primary"
                   icon="el-icon-plus"
                   @click="$router.push('/walks/create')"></el-button>
      </div>
      <div v-if="walkList.length > 0">
        <el-table v-if="walkList"
                  id="walk-table"
                  :data="walkListPage"
                  height="100%">
          <el-table-column class="walk-table-column">
            <template slot-scope="walk">
              <div class="walk-list-flex-container">
                <div class="walk-list-thumbnail">
                  <img :src="walk.row.thumbnailUrl"/>
                </div>
                <div class="walk-list-content">
                    <strong><translate>Title</translate>:</strong>&nbsp;
                    {{walk.row.title}}<br/>
                    <strong><translate>Subtitle</translate>:</strong>&nbsp;
                    {{walk.row.subtitle}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="walk">
              <el-button v-if="$session.exists() && $route.path !=='/'"
                         id="button-edit"
                         icon="el-icon-edit"
                         @click="edit(walk.row.id)"></el-button>
              <el-button v-if="$session.exists() && $route.path !=='/'"
                         id="button-delete"
                         type="danger" icon="el-icon-delete"
                         @click="remove(walk.row.id)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <br />
        <el-pagination background
                       layout="prev, pager, next"
                       :total="walkList.length"
                       :current-page.sync="currentPage"
                       :page-size="pageSize"
                       @current-change="changePage">
        </el-pagination>
        <el-dialog v-if="$session.exists() && isEditVisible"
                   :before-close="handleClose"
                   :visible.sync="isEditVisible">
          <walk-upload-form :loaded-form="walk"
                                @close-edit="closeEdit"
                                preview></walk-upload-form>
        </el-dialog>
      </div>
    </div>
  </template>)

  (<script>
  import axios from 'axios'
  import WalkUploadForm from './Walk-Upload-Form.vue'

  export default {
    name: 'walk-list',
    data () {
      var menuItems = {
        images: 'images'
      }
      return {
        menuItems,
        activeMenuImagesOrMap: menuItems.images,
        isEditVisible: false,
        walkList: [],
        currentPage: 1,
        pageSize: 10,
        walkListPage: []
      }
    },
    created () {
      this.getWalkList()
    },
    components: {
      'walk-upload-form': WalkUploadForm
    },
    methods: {
      changePage () {
        this.walkListPage = this.walkList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      },
      getWalkList () {
        axios({
          method: 'get',
          url: `${process.env.SERVER_URL}/walks?lang=${this.$language.current}`,
          withCredentials: true
        })
        .then(response => {
          this.walkList = response.data
          this.walkListPage = this.walkList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      },
      getWalk (id, callback) {
        axios({
          method: 'get',
          url: `${process.env.SERVER_URL}/walks/${id}`,
          withCredentials: true
        })
        .then(response => {
          this.walk = response.data
          callback(null)
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
          callback(error)
        })
      },
      handleClose (done) {
        this.$confirm(this.$gettext('Are you sure to close?'), {
          confirmButtonText: this.$gettext('Yes'),
          cancelButtonText: this.$gettext('No'),
          type: 'warning'
        }).then(() => {
          done()
        }).catch(() => {})
      },
      edit (id) {
        this.getWalk(id, error => {
          if (!error) {
            this.isEditVisible = true
          }
        })
      },
      closeEdit () {
        this.isEditVisible = false
        this.getWalkList()
      },
      remove (id) {
        this.$confirm(this.$gettext('Are you sure to delete the themed walk?'), {
          confirmButtonText: this.$gettext('Yes'),
          cancelButtonText: this.$gettext('No'),
          type: 'warning'
        }).then(() => {
          axios({
            method: 'delete',
            url: `${process.env.SERVER_URL}/walks/${id}`,
            withCredentials: true
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: this.$gettext('Delete has completed')
            })
            this.getWalkList()
          })
          .catch(error => {
            var msg
            if (error.response) {
              msg = error.response.data || error.response.statusText
            } else {
              msg = error.message
            }
            this.$message({
              type: 'error',
              message: msg
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$gettext('Delete has canceled')
          })
        })
      }
    }
  }
  </script>)

  (<style>
  #walk-table {
    height: 45em;
    overflow: hidden;
  }
  .el-table__body-wrapper {
    overflow-x: hidden;
  }
  .create-button-container {
    text-align: right;
  }
  .el-table td div {
    height: 0%;
  }
  .walk-list-flex-container {
    height: 7em;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
  }
  .walk-list-content {
    margin: auto;
    width: 60%;
    text-align: center;
  }
  .walk-list-thumbnail {
    width: 40%;
    margin: auto;
    height: 80%;
    text-align: center;
  }
  .walk-list-thumbnail > img {
    height: 100%;
    max-width: 150px;
  }
  .preview {
    padding: 5%;
    padding-top: 1%;
    text-align: left;
    max-height: 40em;
    overflow-y: scroll;
    scroll-behavior: smooth;
    line-height: 1em;
  }
  @media screen and (max-width: 1300px) {
    .walk-list-flex-container {
      flex-direction: column;
      height: 10em;
    }
    .walk-list-thumbnail {
      height: 60%;
    }
  }
  .description-content {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
}
  </style>)



// WEBPACK FOOTER //
// src/components/Walk-List-View.vue